/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Bags_TitleInputs */

const vi_sinp_bags_title = /** @type {(inputs: Sinp_Bags_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số bao để in phiếu`)
};

/**

* @param {Sinp_Bags_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_bags_title = /** @type {((inputs?: Sinp_Bags_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Bags_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_bags_title(inputs)
});